export const USER_STATUS = {
    loading: 1,
    logged: 2,
    notFound: 3,
}
